var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnIconActionItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 8.00016C0.333252 7.63196 0.631732 7.3335 0.999919 7.3335H12.9999C13.3681 7.3335 13.6666 7.63196 13.6666 8.00016C13.6666 8.36836 13.3681 8.66683 12.9999 8.66683H0.999919C0.631732 8.66683 0.333252 8.36836 0.333252 8.00016Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5285 3.52876C8.78884 3.26841 9.21097 3.26841 9.4713 3.52876L13.4713 7.52876C13.7316 7.7891 13.7316 8.21123 13.4713 8.47156L9.4713 12.4716C9.21097 12.7319 8.78884 12.7319 8.5285 12.4716C8.26817 12.2112 8.26817 11.7891 8.5285 11.5288L12.0571 8.00016L8.5285 4.47157C8.26817 4.21122 8.26817 3.78911 8.5285 3.52876Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnIconActionItem);
export default __webpack_public_path__ + "static/media/gn-icon_actionItem.ea3d0f6a5f5aaabd039ac5d6daed15cc.svg";
export { ForwardRef as ReactComponent };